
import { Options, Vue } from 'vue-class-component';

import MaterialTopAppBar from '@/components/material/TopAppBar.vue';
import MaterialTopAppBarAdjust from '@/components/material/TopAppBarAdjust.vue';
import AboutPreferences from '@/components/preferences/About.vue';
import BrainstormingPreferences from '@/components/preferences/Brainstorming.vue';
import DataPreferences from '@/components/preferences/Data.vue';
import GeneralPreferences from '@/components/preferences/General.vue';
import GooglePreferences from '@/components/preferences/Google.vue';

import locales from './Preferences.locales.json';

@Options({
    components: {
        MaterialTopAppBar, MaterialTopAppBarAdjust,
        GeneralPreferences,
        GooglePreferences,
        BrainstormingPreferences,
        DataPreferences,
        AboutPreferences,
    },
    i18n: {
        messages: locales
    }
})
export default class Preferences extends Vue {}
